/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getServices.defs.js'
export { main as default } from './getServices.defs.js'
